export const environment = {
  production: true,
  apiUrl: 'https://bllv.fastcache.de'
};
